import { merge } from '../../../helper';

import isEmptyArray from '../../../general/isEmpty/isEmptyArray';

import * as exElement from '../../../utils/element';

import { data } from './utils';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (ul)
    const elList = exElement.create({
        merge: defConfig,
        tag: 'ul',
        class: {
            new: 'list-group',
        },
    });
    elements.element = elList;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If using data
    if (!isEmptyArray(config.data)) {
        // Create element (list items)
        const listItems = data(elements.element, {
            merge: exElement.clear({ ...config }),
        });
        elements.items = listItems;
    }
}

// ----------------------------------------------------------------------------

export { create };
